import { getData, getDataV3, postData } from "@/lib/request";

export const insertNewSheet = (params) =>
  postData("web/list_sheet/insertNewSheet", params);
export const updateSheetDetail = (params) =>
  postData("web/list_sheet/updateSheetDetail", params);
export const updateSheet = (params) =>
  postData("web/list_sheet/updateSheet", params);
export const updateDetailSheet = (params) =>
  postData("web/list_sheet/updateDetailSheet", params);
export const updateDetailSheetV2 = (params) =>
  postData("web/list_sheet/updateDetailSheetV2", params);
export const getListSheet = (params) =>
  getData("web/list_sheet/getListSheet", params);
export const getListSheetDetail = (params) =>
  getData("web/list_sheet/getListSheetDetail", params);
